// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { productPriceStyles } from "@guestsupply/Overrides/Components/ProductPrice";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { css } from "styled-components";

productPriceStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};
// XNG-Changes: GSS-366
productPriceStyles.priceLabelText = {
    ...cartLineSharedStyles.headlineTypography,
};
productPriceStyles.priceWrapper = {
    css: css`
        ${wrapInContainerStyles}
    `,
};
productPriceStyles.price = {
    priceText: { weight: "bold", size: 18 },
    errorText: { weight: "bold" },
    realTimeText: {
        weight: "bold",
        size: 18,
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText: {
            size: 13,
            css: css`
                white-space: nowrap;
                margin-left: 4px;
            `,
        },
    },
    vatLabelText: {
        css: css`
            font-size: 12px;
        `,
    },
};
productPriceStyles.invalidPriceText = {
    color: "danger",
};
productPriceStyles.secondaryPriceWrapper = {
    css: css`
        margin-top: 5px;
        ${wrapInContainerStyles}
    `,
};
productPriceStyles.secondaryPrice = {
    priceText: { weight: "bold" },
    errorText: { weight: "bold" },
    realTimeText: {
        weight: "bold",
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText: {
            css: css`
                white-space: nowrap;
                margin-left: 4px;
            `,
        },
    },
    vatLabelText: {
        css: css`
            font-size: 12px;
        `,
    },
};
productPriceStyles.packWrapper = {
    css: css`
        margin-bottom: 8px;
    `,
};
productPriceStyles.packLabelText = {
    weight: "bold",
};
productPriceStyles.savingsMessageText = {
    italic: true,
    size: "12px",
};
productPriceStyles.quoteMessage = {
    text: { weight: "bold" },
};
productPriceStyles.fromTextTypography = {
    size: 13,
    css: css`
        margin-right: 4px;
    `,
};
